/**
 * Footer Component
 */
import React from 'react'
import styled from '@emotion/styled'

const StyledFooter = styled.footer`
  height: 140px;
  justify-content: center;
  background-color: #222;
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: center;
  flex-direction: column;
`

const FooterLinks = styled.div`
  display: flex;
  flex-direction: row;

  a {
    color: #496ee8;
    font-size: 14px;
    margin: -1rem 1.2rem 1rem;
  }
`

const FooterText = styled.span`
  margin: 0.2rem;
`

const Footer: React.FC = () => {
  return (
    <StyledFooter>
      <FooterLinks>
        <a href="https://www.kidsland.com.cn/nd.jsp?id=90" target="_blank" rel="noreferrer">
          法律聲明
        </a>
        <a href="https://www.kidsland.com.cn/col.jsp?id=127" target="_blank" rel="noreferrer">
          聯繫我們
        </a>
        <a>加入我們</a>
      </FooterLinks>
      <FooterText>©2019 kidsland凯知乐 版权所有</FooterText>
      <FooterText>京ICP备18020377号</FooterText>
    </StyledFooter>
  )
}

export default Footer
